export const mixed = {
  default: '${label} is ongeldig.',
  required: '${label} is een verplicht veld',
  oneOf: '${label}  moet één van de volgende waarden zijn: ${values}',
  notOneOf: '${label} is niet valide',
  notType: '${label} is niet valide',
};

export const string = {
  length: '${label}  moet precies ${length} karakters lang zijn',
  min: '${label}  moet minimaal ${min} karakters bevatten',
  max: '${label}  mag maximaal ${max} tekens bevatten',
  matches: '${label}  moet overeenkomen met het volgende: "${regex}"',
  email: '${label}  moet een geldig e-mailadres zijn',
  url: '${label}  moet een geldige URL zijn',
  trim: '${label}  mag geen begin- of eindspaties bevatten',
  lowercase: '${label}  mag alleen bestaan uit kleine letters',
  uppercase: '${label}  mag alleen bestaan uit hoofdletters',
};

export const number = {
  min: '${label}  moet groter dan of gelijk zijn aan ${min}',
  max: '${label}  moet lager dan of gelijk zijn aan ${max}',
  lessThan: '${label}  moet lager zijn dan ${less}',
  moreThan: '${label}  moet hoger zijn dan ${more}',
  positive: '${label}  moet een positief getal zijn',
  negative: '${label}  moet negatief getal zijn',
  integer: '${label}  moet een getal zijn',
};

export const date = {
  min: '${label}  moet later dan ${min} zijn',
  max: '${label}  moet eerder dan ${max} zijn',
};

export const boolean = {};

export const object = {
  noUnknown: '${label}  mag geen waarden bevatten die niet zijn opgegeven in het object',
};

export const array = {
  min: ({ min, label }: { label: string; min: number }) =>
    `${label}  moet ten minste ${min} item${min > 1 ? 's' : ''} bevatten`,
  max: '${label}  moet minder of gelijk zijn aan ${max} items',
};
